/**
 * Cliente API com token de sessão (FASE 0/1 multi-tenant).
 * Todas as chamadas ao backend devem usar apiFetch para enviar o token.
 */
import API_CONFIG from '../config/api';

const TOKEN_KEY = 'sessionToken';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

/**
 * fetch que adiciona Authorization: Bearer <token> em requisições ao backend.
 * @param {string} url - URL completa ou path (ex: '/api/prestadores')
 * @param {RequestInit} [options]
 */
export function apiFetch(url, options = {}) {
  const fullUrl = url.startsWith('http') ? url : `${API_CONFIG.BACKEND_URL}${url}`;
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  return fetch(fullUrl, { ...options, headers });
}

function appendAccessToken(url) {
  const token = getToken();
  if (!token) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}access_token=${encodeURIComponent(token)}`;
}

/** URL de arquivo em /uploads com token de sessão (após proteção do backend). */
export function getAuthenticatedUploadUrl(relativePath) {
  if (!relativePath) return '';
  const clean = String(relativePath).replace(/^\/+/, '').replace(/^uploads\//, '');
  return appendAccessToken(`${API_CONFIG.BACKEND_URL}/uploads/${clean}`);
}

/**
 * Abre PDF/arquivo de /uploads numa nova aba com access_token (evita NO_TOKEN).
 * Aceita URL completa, path relativo ou uploads/...
 */
export function openAuthenticatedUpload(urlOrPath) {
  if (!urlOrPath) return;
  let path = String(urlOrPath).trim();
  try {
    if (/^https?:\/\//i.test(path)) {
      const u = new URL(path);
      path = u.pathname || '';
    }
  } catch {
    /* mantém path original */
  }
  path = path.replace(/^\/+/, '');
  if (path.startsWith('uploads/')) path = path.slice('uploads/'.length);
  const authUrl = getAuthenticatedUploadUrl(path);
  if (authUrl) window.open(authUrl, '_blank', 'noopener,noreferrer');
}

/** URL de rota da API (ex.: PDF) com token para abrir em nova aba. */
export function getAuthenticatedApiUrl(apiPath) {
  const path = apiPath.startsWith('/') ? apiPath : `/${apiPath}`;
  return appendAccessToken(`${API_CONFIG.BACKEND_URL}${path}`);
}
